import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {VideoCameraFilled, CheckSquareFilled} from '@ant-design/icons'

const VideoProduct = ({product}) => {
  const variants = {
    some15: 'Vertikal 30',
    aero15: 'Dronevideo 15',
    aero20: 'Dronevideo 20',
    aero30: 'Dronevideo 30',
    aero40: 'Dronevideo 40',
    some_horizontal: 'SoMe Horisontal',
    video30: 'Horisontal 30',
    video90: 'Horisontal 90',

    vertical30: 'Vertikal 30',
    horizontal30: 'Horisontal 30',
    horizontal90: 'Horisontal 90',
    video15: 'Video 15',
    video20: 'Video 20',
    video40: 'Video 40',
    video45: 'Video 45',
    video60_drone: 'Video 60 + drone',
    video_40_aero_stills: 'Dronevideo 40 + stills',
    video_60_aero_stills: 'Dronevideo 60 + stills',
    video_viewing: 'Videovisning',
    videobundle: 'Videobundle',
    parallax: 'Parallax Video',
  }

  const {videoVariant, drone, teaser} = product
  const variantLabel = variants[videoVariant] || videoVariant

  return (
    <div className="selected-product-options VideoProduct">
      <IconLabel icon={<VideoCameraFilled />} label={variantLabel} />
      {drone && (
        <IconLabel icon={<CheckSquareFilled />} label="Med drone" />
      )}
      {teaser && (
        <IconLabel icon={<CheckSquareFilled />} label="Med teaser" />
      )}
    </div>
  )
}

VideoProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default VideoProduct
